<template>
  <img
    src="	https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/png/BFZMNTK013456789_1595558029.png"
    class="corporateCulture-img banCopy"
  />

  <nav class="banCopy">
    <ul
      class="
        corporateCulture-nav-list
        list-unstyled list-group
        fixed-left
        d-none d-lg-block
      "
    >
      <li
        class="list-group-item hand"
        :class="{ active: isCorporateCultureActive == 1 }"
        @click="handoffDispalyConstruction($event)"
      >
        党群建设
      </li>
      <li
        class="list-group-item hand"
        :class="{ active: isCorporateCultureActive == 2 }"
        @click="handoffDispalyCulture($event)"
      >
        杭开文化
      </li>
    </ul>
  </nav>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      isCorporateCultureActive: 1,
    };
  },
  mounted() {
    document.title="杭开集团-企业文化";

    var url = this.$route.fullPath;
    if (url == "/corporateCulture/construction") {
      this.isCorporateCultureActive = 1;
    } else if (url == "/corporateCulture/culture") {
      this.isCorporateCultureActive = 2;
    }
  },
  methods: {
    handoffDispalyConstruction() {
      this.$router.push("/corporateCulture/construction");
      this.isCorporateCultureActive = 1;
    },
    handoffDispalyCulture() {
      this.$router.push("/corporateCulture/culture");
      this.isCorporateCultureActive = 2;
    },
  },
  watch: {
    $route: function (to, from) {
      if (to.fullPath != from.fullPath) {
        if (to.fullPath == "/corporateCulture/construction") {
          this.isCorporateCultureActive = 1;
        } else if (to.fullPath == "/corporateCulture/culture") {
          this.isCorporateCultureActive = 2;
        }
      }
    },
  },
};
</script>

<style >
.culture-box {
  margin-top: 0rem;
  margin-bottom: 10rem;
}

.hkwh {
  color: #e8623e;
  text-align: center;
  /* padding-bottom: 40px; */
  display: block;
  font-size: 3em;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  margin-top: 10rem;
}

.corporateCulture-img {
  width: 100vw;
}

.construction-body-div {
  width: 100vm;
  background-color: transparent;
  transition-duration: 0.8s;
  padding-top: 5rem;
  /* padding-bottom: 10rem; */
}

.construction-img-box {
  overflow: hidden;
  width: 100%;
}

.construction-title-div {
  display: block;
  width: 100vm;
  text-align: center;
  padding: 6.25rem;
}

.construction-list-item {
  width: 26rem;
  margin-bottom: 3.75rem;
  transition-duration: 0.8s;
  background-color: #fff;
}

.construction-list {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
}

.construction-item-box {
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 0.375rem;
  border-radius: 0.3rem;
  /* overflow: hidden; */
}

.construction-item-box:hover .construction-img {
  transform: scale(1.2);
  transition-duration: 0.5s;
}

.construction-item-box:hover .construction-item-title {
  color: #237efe;
}

.construction-item-title-box {
  height: 0;
  padding-top: 50%;
  position: relative;
}

.construction-item-title {
  color: #363636;
  letter-spacing: 0.2rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.construction-img {
  width: 100%;
  transition-duration: 0.3s;
}

.construction-modal-div {
  background-color: #2d2d2db3;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  transform: all 0.3s;
  display: block;
  color: #fff;
  display: none;
  text-align: center;
  flex-direction: column;
  padding: 0 2.3rem 0 2.3rem;
}

.construction-modal-title {
  color: #fff;
  width: 100%;
  margin: 2rem 0 2rem 0;
}

.construction-modal-content {
  color: #fff;
  width: 100%;
  line-height: 1.8rem;
  letter-spacing: 0.15rem;
}

.construction-modal-button {
  /* width: 100%; */
  position: absolute;
  bottom: 1rem;
  width: 35%;
  height: 2rem;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.2rem;
  margin: 0 auto;
  left: 34%;
}

@media screen and (max-width: 1218px) {
  .construction-list {
    width: 100%;
  }

  .construction-list-item {
    width: 40%;
    transition-duration: 0.8s;
  }

  .construction-body-div {
    background-color: #fff;
    transition-duration: 0.8s;
  }
}

@media screen and (max-width: 991px) {
  .construction-item-title,
  .construction-item-timeText {
    font-size: 0.8rem;
  }
}
</style>